<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card
        v-card-title.px-4.h6.basic800--text
          div(v-if="product") {{ $t('edit') }} {{ $t('addon') }}
          div(v-else) {{ $t('new') }} {{ $t('addon') }}
        v-divider.basic300
        v-card-text.px-0
          v-form(ref="form")
            div.pa-4(style="overflow-x: hidden;")
              .product-image.d-flex
                p.h6.basic1000--text {{ $t('product_image') }}
                v-spacer
                div.file-layout(v-if="resizeImageFileUrl")
                  v-btn.button-Aa-tiny.custom-transform-class.text-none.px-2(color="textColorAccent" text small)
                    eva-icon.mr-2(name="edit-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" height="12" width="12" style="margin-top: 1px")
                    | {{ $t('change_image') }}
                  input.input-layout(type="file" @change="onFileChange" accept="image/*" style="width: 120px !important")

              v-card.mb-3(v-if="resizeImageFileUrl" flat)
                div(align="center")
                  v-img(:src="resizeImageFileUrl" aspect-ratio="1" width="202")
                    template(v-slot:placeholder)
                      v-row(class="fill-height ma-0" align="center" justify="center")
                        v-progress-circular(indeterminate color="grey")
              v-card.mb-3(v-else outlined height="203" :style="{ 'background-color': $vuetify.theme.themes[$theme].primaryT08 }")
                div.fill-height
                  div.d-flex.justify-center.align-end(style="height: 70%")
                    div
                      div.mb-2(align="center")
                        eva-icon(name="image-outline" :fill="$vuetify.theme.themes[$theme].primaryT32" height="38" width="38")
                      div.file-layout.mb-4
                        v-btn.button-AA-tiny(color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}") {{ $t('upload') }}
                        input.input-layout(type="file" @change="onFileChange" accept="image/*" style="width: 60px !important")
                  div.d-flex.justify-center.align-end(style="height: 30%")
                    div.mb-4
                      div.c1.basic600--text.text-center {{ $t('max_image_filesize') }}
                      div.c1.basic600--text.text-center {{ $t('recommended_image_size') }}

              p.h6.basic1000--text.mt-5 {{ $t('details') }}

              .product-name
                p.mb-1.label.basic600--text.text-uppercase {{ $t('product_name.label') }}*
                v-text-field.mt-2(v-model='name' :placeholder="$t('product_name.placeholder')" background-color="basic200" outlined dense height="40" persistent-hint :rules="rules.not_empty" counter :maxlength="145")

              .product-price
                p.mb-1.label.basic600--text.text-uppercase {{ $t('price.label') }}*
                v-text-field.mt-2(v-model='price' :placeholder="$t('price.placeholder')" background-color="basic200" outlined dense height="40" type="number" :rules="rules.has_price" :prefix="$currency.symbol")

              .weight(v-if="setweight")
                p.mb-1.label.basic600--text.text-uppercase {{ $t('weight.label') }}*
                v-text-field.mt-2(v-model='weight' :placeholder="$t('weight.placeholder')" background-color="basic200" height="40" outlined dense type="number" :rules="setweight ? rules.weight : []" suffix="kg" )

              .dimension(v-if="setdimension")
                p.mb-1.label.basic600--text.text-uppercase {{ $t('dimension.label') }}*
                div.d-flex
                  v-text-field.mt-2(v-model='length' :placeholder="$t('dimension.placeholder_1')" background-color="basic200" height="40" outlined dense type="number" :rules="setdimension ? rules.dimension : []" suffix="cm")
                  div.basic600--text.mt-4.mx-1 X
                  v-text-field.mt-2(v-model='width' :placeholder="$t('dimension.placeholder_2')" background-color="basic200" height="40" outlined dense type="number" :rules="setdimension ? rules.dimension : []" suffix="cm")
                  div.basic600--text.mt-4.mx-1 X
                  v-text-field.mt-2(v-model='height' :placeholder="$t('dimension.placeholder_3')" background-color="basic200" height="40" outlined dense type="number" :rules="setdimension ? rules.dimension : []" suffix="cm")

              .description
                p.mb-1.label.basic600--text.text-uppercase {{ $t('description.label') }}
                v-textarea.mt-2(v-model='description' :placeholder="$t('description.placeholder')" outlined dense persistent-hint counter background-color="basic200")
                .guide.mb-2.d-flex
                  eva-icon.mr-2(name="info-outline" :fill="$vuetify.theme.themes[$theme].basic600" height="15" width="15")
                  div.c1.basic600--text {{ $t('for_optimized_design') }}

              p.h6.basic1000--text.mt-5 {{ $t('inventory') }}

              .inventory.d-flex
                y-checkbox.my-auto.mx-0.pa-0(v-model="inventory" hide-details)
                  template(v-slot:label)
                    div.p1.my-auto {{ $t('product_limited_stock') }}

              .quantity.mt-6(v-if="inventory")
                p.mb-1.label.basic600--text.text-uppercase {{ $t('quantity.label') }}*
                v-text-field.mt-2(ref='quantity' v-model='quantity' :placeholder="$t('quantity.placeholder')" background-color="basic200" height="40" hide-details outlined dense type="number")

        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-small.primary400--text {{ $t('cancel') }}
          v-btn.mr-2(color='textColorAccent' depressed height=32 @click="clickSave" :loading="isLoading")
            .button-AA-small.basic100--text(v-if="product") {{ $t('save') }}
            .button-AA-small.basic100--text(v-else) {{ $t('add') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { resizeImage } from '@/utils'

export default {
  name: 'AddNewAddOnDialog',
  props: ['open', 'productId', 'product', 'setweight', 'setdimension'],
  data: () => ({
    name: null,
    price: null,
    weight: null,
    length: null,
    width: null,
    height: null,
    description: null,
    inventory: false,
    quantity: null,
    members: '',
    openEditVariantDialog: false,
    openManageAddOnsDialog: false,
    isLoading: false,
    option: null,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      number_not_empty: [v => v !== null || 'This field is required'],
      is_selected: [(v) => v !== null || 'This field is required'],
      has_price: [(v) => v !== null  || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v != 0|| 'This field is required'],
      has_items: [(v) => !!v || 'This field is required'],
      weight: [
        v => !!v || 'This field is required',
        v => v >= 0.1 || 'Weight should not be below 0.1 KG',
        v => v <= 60 || 'Weight should not be above 60 KG',
      ],
      dimension: [v => !!v || 'This field is required', v => v > 0 || 'measure should not be below 1 cm'],
    },
    resizeImageFileUrl: '',
    resizeImageFile: null
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    authMember () {
      return this.$store.state.user.member
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    if (this.product) {
      if (this.product.image) {
        this.resizeImageFileUrl = this.product.image.file
      }
      this.name = this.product.name
      this.price = this.product.price/this.$currency.multiplier
      this.weight = this.product.weight
      this.length = this.product.length
      this.width = this.product.width
      this.height = this.product.height
      this.description = this.product.description
      this.quantity = this.product.inventory_qty || 0
      if (this.product.inventory_enabled) {
        this.inventory = true
      }
      if (this.product.members) {
        this.members = this.product.members
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    getSearchText (item) {
      return item.user.first_name + ' ' + item.user.last_name + ' ' + item.user.email
    },
    // updateInventory (val) {
    //   this.inventory = val
    // },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      var memberIds = [this.authMember.id]
      this.isLoading = true
      var params = new FormData();
      params.set('company', this.company.id)
      params.set('name', this.name)
      params.set('price', (parseFloat(this.price)).toFixed(this.$currency.exponent).replace('.', ''))
      if (this.weight) {
        params.set('weight', this.weight)
      }
      if (this.length) {
        params.set('length', this.length)
      }
      if (this.width) {
        params.set('width', this.width)
      }
      if (this.height) {
        params.set('height', this.height)
      }
      params.set('description', this.description)
      if (this.inventory) {
        params.set('inventory_qty', this.quantity)
        params.set('inventory_enabled', true)
      } else {
        params.set('inventory_enabled', false)
      }
      if (this.resizeImageFile) {
        params.append('image', this.resizeImageFile)
      }
      memberIds.forEach(mid => {
        params.set('members', mid)
      })
      if (this.product) {
        this.axios.put(`/products/${this.product.id}/`, params)
          .then(resp => {
            this.showModal = false
            this.showMessage(['success', this.$t('success_message.product_edited')])
            this.$emit('update:product', resp.data)
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isLoading = false
          })
          return
      }
      this.axios.post(`/products/${this.productId}/addons/`, params)
        .then(resp => {
          this.showModal = false
          this.showMessage(['success', this.$t('success_message.product_added')])
          this.$emit('added', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async onFileChange (e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      const resizedImage = await resizeImage(files[0], 'product_image.jpeg')
      this.resizeImageFileUrl = resizedImage.dataURL
      this.resizeImageFile = resizedImage.file
    },
    onFilterChanged () {
      setTimeout(() => {
        this.$refs.selectMembers.isMenuActive = false
      }, 50)
    }
  }
}
</script>

<style scoped>
.container-image {
  border-style: solid;
  border-width: 1px;
  border-color: grey;
  border-radius: 2px;
}
.file-layout {
  position: relative;
}
.input-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
.background-inventory {
  border-style: solid;
  border-width: 1px;
  border-color: grey;
  border-radius: 2px;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "product_name": {
      "label": "Name",
      "placeholder": "Write product name here"
    },
    "price": {
      "label": "Price",
      "placeholder": "0"
    },
    "weight": {
      "label": "Weight",
      "placeholder": "Min = 0.1 kg | Max = 60 kg"
    },
    "description": {
      "label": "Description",
      "placeholder": "Write product description here"
    },
    "quantity": {
      "label": "Quantity",
      "placeholder": "How many stock left"
    },
    "dimension": {
      "label": "Dimension",
      "placeholder_1": "Length",
      "placeholder_2": "Width",
      "placeholder_3": "Height"
    }
  },
  "id": {
    "product_name": {
      "label": "Nama",
      "placeholder": "Tulis Nama Produk di sini"
    },
    "price": {
      "label": "Harga",
      "placeholder": "0"
    },
    "weight": {
      "label": "Berat",
      "placeholder": "Min = 0.1 kg | Maks = 60 kg"
    },
    "description": {
      "label": "Deskripsi",
      "placeholder": "Tulis Deskripsi di sini"
    },
    "quantity": {
      "label": "Jumlah",
      "placeholder": "Berapa sisa stok"
    },
    "dimension": {
      "label": "Dimensi",
      "placeholder_1": "panjang",
      "placeholder_2": "lebar",
      "placeholder_3": "tinggi"
    }
  }
}
</i18n>
